<template>
  <el-radio-group
    v-model="value"
    v-on="$listeners"
    v-bind="{ ...$props }"
    multiple
    class="radio-group"
    :class="{
      'boole-small' : size === 'small'
    }"
  >
    <template v-if="type === 'string'">
      <el-radio
        v-for="item in options"
        :disabled="item.disabled"
        :key="item.choiceKey"
        :label="item.choiceKey"
        :title="item.value"
      >{{ item.value }}
      </el-radio
      >
    </template>
    <template v-if="type === 'boolean'">
      <el-radio
        v-for="item in options"
        :disabled="item.disabled"
        :key="item.choiceKey"
        :label="item.choiceKey === 'true'"
        :title="item.value"
      >{{ item.value }}
      </el-radio
      >
    </template>
  </el-radio-group>
</template>

<script>
  import {booleProps} from '../index.js'

  export default {
    props: booleProps,
    model: {
      prop: 'value',
      event: 'change'
    },
    mounted () {
      if (this.value) {
        this.$emit('change', this.value)
      }
    },
    computed: {
      type () {
        return typeof this.value
      }
    }
  }
</script>

<style scoped lang="scss">
.radio-group {
  ::v-deep .el-radio{
    height: 32px;
    line-height: 32px;
    max-width: 290px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
